"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Breakpoint = void 0;
let Breakpoint;
exports.Breakpoint = Breakpoint;

(function (Breakpoint) {
  Breakpoint["xs"] = "xs";
  Breakpoint["sm"] = "sm";
  Breakpoint["md"] = "md";
  Breakpoint["lg"] = "lg";
  Breakpoint["xl"] = "xl";
  Breakpoint["xxl"] = "xxl";
  Breakpoint["fullhd"] = "fullhd";
  Breakpoint["ultrahd"] = "ultrahd";
})(Breakpoint || (exports.Breakpoint = Breakpoint = {}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJCcmVha3BvaW50Il0sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3RoZW1lL2JyZWFrcG9pbnRzL2JyZWFrcG9pbnRzLnR5cGVzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBlbnVtIEJyZWFrcG9pbnQge1xuICB4cyA9ICd4cycsXG4gIHNtID0gJ3NtJyxcbiAgbWQgPSAnbWQnLFxuICBsZyA9ICdsZycsXG4gIHhsID0gJ3hsJyxcbiAgeHhsID0gJ3h4bCcsXG4gIGZ1bGxoZCA9ICdmdWxsaGQnLFxuICB1bHRyYWhkID0gJ3VsdHJhaGQnLFxufVxuXG5leHBvcnQgdHlwZSBCcmVha3BvaW50cyA9IFJlY29yZDxCcmVha3BvaW50LCBudW1iZXI+XG4iXSwibWFwcGluZ3MiOiI7Ozs7OztJQUFZQSxVOzs7V0FBQUEsVTtFQUFBQSxVO0VBQUFBLFU7RUFBQUEsVTtFQUFBQSxVO0VBQUFBLFU7RUFBQUEsVTtFQUFBQSxVO0VBQUFBLFU7R0FBQUEsVSwwQkFBQUEsVSJ9